<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.subject_treemaps', 2),
                        href: meta.links.index,
                    },
                    {
                        name: subjectTreemap.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <span>{{ subjectTreemap.subject_name }}</span>
        </div>

        <div>
            <div class="flex gap-2 items-center">
                <NavLinks :links="meta.navLinks.modes" class="mt-3" />
            </div>
        </div>

        <div class="mt-3" v-if="filters.group_id">
            <div class="mt-5" v-if="treeMapAnalysis">
                <SubjectTreemapAnalysis :treemap-analysis="treeMapAnalysis" />
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import NavLinks from '../../../../../components/NavLinks.vue';
import SubjectTreemapAnalysis from '../../../../Teacher/Activities/SubjectTreemaps/partials/SubjectTreemapAnalysis.vue';
import SmartBreadcrumbs from '../../../../../components/SmartBreadcrumbs.vue';

export default {
    components: {
        SmartBreadcrumbs,
        SubjectTreemapAnalysis,
        NavLinks,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'filters', 'treeMapAnalysis', 'subjectTreemap'],
    data() {
        return {
            form: this.$inertia.form({
                mode: this.filters.mode,
                group_id: this.filters.group_id,
                student_id: this.filters.student_id,
            }),
        };
    },
};
</script>
